import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { GET_CHAT_CLICKED, GET_HELP_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { HELP_MOBILE } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';

const SupportPopup = ({ popupRef = null, ...props }) => {
    const helpLink = `${getLangCountryPrefix(props.lang, props.country)}${HELP_MOBILE}`;

    return (
        <SimplePopup withoutBorder popupRef={popupRef}>
            <PopupButton
                href={helpLink}
                iconName="info-rounded"
                text={props.morePopupFaqTitle}
                onClick={() => {
                    amplitude.getInstance().logEvent(GET_HELP_CLICKED);
                    popupRef.current?.close();
                }}
            />
            <PopupButton
                iconName="message-bubble"
                text={props.morePopupChatTitle}
                onClick={(e) => {
                    e.preventDefault();
                    amplitude.getInstance().logEvent(GET_CHAT_CLICKED);
                    popupRef.current?.close();
                    props.toggleChat(true);
                }}
            />
        </SimplePopup>
    );
};

SupportPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => ({
    morePopupChatTitle: state.messages.pageMessages.morePopupChatTitle,
    morePopupFaqTitle: state.messages.pageMessages.morePopupFaqTitle,
    lang: state.language.lang,
    userCountry: state.extra?.userCountry,
    country: state.app.country,
});
export default connect(mapStateToProps, { toggleModal, toggleChat })(SupportPopup);
